import { FC } from 'react';

import { Typography } from 'enable-ui';

import { Station } from '../core/type';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const StationCard: FC<{
  station: Station;
  onClick: () => void;
}> = ({ station, onClick }) => {
  const textStyle = {
    fontSize: 16,
    lineHeight: '22px',
    color: COLOR_CONFIG['neutral-text'],
  };

  return (
    <div
      style={{
        border: `1px solid ${COLOR.neutralTrans['neutralTrans-25']}`,
        borderRadius: 16,
        padding: '12px 16px 16px 16px',
        height: 176,
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <div style={{ marginBottom: 12 }}>
        <Typography weight={600} style={{ ...textStyle }}>
          {station.stationId}
        </Typography>
        <Typography
          weight={600}
          style={{ fontSize: 18, lineHeight: '26px' }}
          color={COLOR.surfaceNeutralBold['neutral-11']}
        >
          {station.name}
        </Typography>
      </div>
      <Typography style={{ ...textStyle }}>
        {station.address && `${station.address}, `}
        {station.city && `${station.city}`}
        {station.state && `, ${station.state}`}
        {station.country && `, ${station.country}`}
      </Typography>
    </div>
  );
};
